import React from "react";
import privacy_tab_data from "../data/PRIVACY_TAB_DATA.json";

interface PrivacyTabData {
  text: string;
}

const PrivacyTab = () => {
  const privacyData = privacy_tab_data as PrivacyTabData;

  return (
    <div>
      <div className="mb-2">
        <h2>Our Privacy</h2>
      </div>
      <div className="text-sm">{privacyData.text}</div>
    </div>
  );
};

export default PrivacyTab;
